import { createRouter, createWebHistory } from "vue-router";
import IssuerHub from "../views/IssuerHub.vue";

//Make acpt use the same slug
let hostname = window.location.hostname.replace("staging.internal.", "");

if (hostname.startsWith("www.")) {
  // trim the "www." from the URL
  hostname = hostname.slice(4);
}

// Dynamic environments are served as app-<branch>.staging.internal.gentwo.com, which the strip
// above leaves as app-<branch>.gentwo.com. Normalise those too, or the /public-issuers/:slug
// route below never registers and the page renders blank - even though the backend hands out
// https://app-<branch>.../public-issuers/{0} links on those environments.
hostname = hostname.replace(/^app-[^.]+\.gentwo\.com$/, "app.gentwo.com");

// The dev server serves this entry under /public-issuers/ as well (see rewrite-middleware in
// vite.config.mjs), so localhost needs the same base and routes as app.gentwo.com.
hostname = hostname.replace(/^localhost$/, "app.gentwo.com");

const hasOwnPublicDomain = !hostname?.includes("gentwo.com") && !hostname?.includes("localhost");
let routes = [];
let baseUrlWebHistory = "/public-issuers";

if (hasOwnPublicDomain) {
  baseUrlWebHistory = import.meta.env.BASE_URL;
  
  routes = [
    {
      path: "/",
      name: "IssuerHub",
      component: IssuerHub,
      props: { slug: hostname },
    },
    {
      path: "/product/:isin",
      name: "Product",
      component: () => import("../views/IssuerProduct.vue"),
      props: route => ({ slug: hostname, isin: route.params.isin }),
    },
    {
      path: "/:catchAll(.*)",
      name: "NotFound",
      redirect: "/not-found",
    },
  ];
} else {
  const isFromG2Pro = hostname === "app.gentwo.com";
  const slug = hostname.replace(".gentwo.com", ".com");
  baseUrlWebHistory = isFromG2Pro ? "/public-issuers" : "/";

  routes = [
    {
      path: isFromG2Pro ? "/:slug" : "/",
      name: "IssuerHub",
      component: IssuerHub,
      props: isFromG2Pro ? true : { slug: slug },
    },
    {
      path: isFromG2Pro ? "/:slug/product/:isin" : "/product/:isin",
      name: "Product",
      component: () => import("../views/IssuerProduct.vue"),
      props: isFromG2Pro ? true : route => ({ slug: slug, isin: route.params.isin }),
    },
    {
      path: "/:catchAll(.*)",
      name: "NotFound",
      redirect: "/not-found",
    },
  ];
}

const router = createRouter({
  history: createWebHistory(baseUrlWebHistory),
  routes,
  scrollBehavior() {
    return {
      top: 0,
    };
  },
});

router.onError(error => {
  if (
    router.pending?.fullPath &&
    (error?.name === "ChunkLoadError" ||
      (error?.name === "TypeError" && error?.message?.includes("dynamically imported module")) ||
      (error?.name === "Error" && error?.message?.includes("Unable to preload CSS")))
  ) {
    // try to reload the desired view
    window.location.assign(router.pending.fullPath);
  } else {
    // else, just reload
    window.location.reload();
  }
});

export default router;
